import { makeStyles } from 'tss-react/mui';
import GroupField from '../forms/group-field';
import MaterialLink from '../material-link';

const useStyles = makeStyles()((theme) => ({
  field: {
    marginBottom: theme.spacing(1),
  },
}));

type Props = {
  disabled: boolean;
  forceTouched: boolean;
  [key: string]: unknown;
};

const EventFormGroup = ({ disabled, forceTouched, ...rest }: Props) => {
  const { classes } = useStyles();

  return (
    <GroupField
      name="groupId"
      label="Group"
      disabled={disabled}
      touched={forceTouched}
      helperText={(
        <MaterialLink href="/groups/new" target="_blank">
          Create a Group
        </MaterialLink>
      )}
      placeholder="No Group"
      className={classes.field}
      permission="createEvent"
      {...rest}
    />
  );
};

export default EventFormGroup;
